import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faArchive, faBurn, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BBadge } from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { userOwnsHistory } from "@/api";
import { useUserStore } from "@/stores/userStore";
import localize from "@/utils/localization";
import UtcDate from "../UtcDate.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'HistoryIndicators',
    props: {
        history: null,
        includeCount: { type: Boolean },
        detailedTime: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        library.add(faArchive, faBurn, faTrash);
        const userStore = useUserStore();
        const { currentUser } = storeToRefs(userStore);
        return { __sfc: true, userStore, currentUser, props, faArchive, faBurn, faTrash, FontAwesomeIcon, BBadge, userOwnsHistory, localize, UtcDate };
    }
});
